import { render, staticRenderFns } from "./DishCard.vue?vue&type=template&id=ca52505c&scoped=true&"
import script from "./DishCard.vue?vue&type=script&lang=js&"
export * from "./DishCard.vue?vue&type=script&lang=js&"
import style0 from "./DishCard.vue?vue&type=style&index=0&id=ca52505c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca52505c",
  null
  
)

export default component.exports